import { getToken } from '@/utils/auth'

export default () => {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Api-Key': process.env.VUE_APP_API_KEY,
    }

    if (getToken()) {
        /* Set the Authorization token for all requests */
        headers.Authorization = `Bearer ${getToken()}`
    }

    return headers
}
